import { ApiResponse } from "../../../types/api";
import apiClient from "../../apiClient";
import {
  Role,
  RolesResponse,
  GetRolesParams,
  UpdateRoleRequest,
  CreateRoleRequest,
} from "./type";

const ROLES_ENDPOINT = "/roles";

export const roleService = {
  getRole: async (id: string): Promise<Role> => {
    const response = await apiClient.get<ApiResponse<Role>>(
      `${ROLES_ENDPOINT}/${id}`,
    );
    return response.data.data;
  },

  getRoles: async (params: GetRolesParams = {}): Promise<RolesResponse> => {
    const searchParams = new URLSearchParams();

    if (params.skip !== undefined) {
      searchParams.append("skip", params.skip.toString());
    }
    if (params.limit !== undefined) {
      searchParams.append("limit", params.limit.toString());
    }
    if (params.search) {
      searchParams.append("search", params.search);
    }

    const response = await apiClient.get<ApiResponse<RolesResponse>>(
      `${ROLES_ENDPOINT}/?${searchParams.toString()}`,
    );
    return response.data.data;
  },

  createRole: async (data: CreateRoleRequest): Promise<Role> => {
    const response = await apiClient.post<ApiResponse<Role>>(
      `${ROLES_ENDPOINT}/`,
      data,
    );
    return response.data.data;
  },

  updateRole: async (
    roleId: string,
    data: UpdateRoleRequest,
  ): Promise<Role> => {
    const response = await apiClient.put<ApiResponse<Role>>(
      `${ROLES_ENDPOINT}/${roleId}`,
      data,
    );
    return response.data.data;
  },

  deleteRole: async (roleId: string): Promise<void> => {
    await apiClient.delete(`${ROLES_ENDPOINT}/${roleId}`);
  },
};

export type {
  Role,
  RolesResponse,
  GetRolesParams,
  UpdateRoleRequest,
  CreateRoleRequest,
};
